module.exports = __webpack_public_path__ + "img/394-498ce5.png";